import withPresets from '@xingternal/with-presets';
import SuperEllipseShell from './SuperEllipseShell';

import * as skins from './super-ellipse-skins';

export default withPresets(skins)(SuperEllipseShell);
